import $ from 'jquery';

export default class Notifications {
	constructor() {
		this.notificationsClose = $('.notifications__close');
	}

	init() {
		this.notificationsClose.on('click', function (event) {
			event.preventDefault();

			$(this).parent().slideUp();
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/notifications/index.js